import { useI18n } from '@ecom/i18n';
import { Badge, type BadgeTone } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

import { MERCHANT_STATUS_LABEL_KEY, type MerchantStatus } from '../types';

/** `Record<MerchantStatus, ...>` — exhaustive over the 4 real statuses, compile-checked. */
const STATUS_TONE: Record<MerchantStatus, BadgeTone> = {
  pending: 'warn',
  active: 'good',
  suspended: 'critical',
  refused: 'critical',
};

export function MerchantStatusBadge({ status }: { status: MerchantStatus }): ReactElement {
  const { t } = useI18n();
  return <Badge tone={STATUS_TONE[status]}>{t(MERCHANT_STATUS_LABEL_KEY[status])}</Badge>;
}
